class BlogSwiper {
  constructor(container) {
    this.container = container;
    this.sliderControls = container.querySelector('.beast_blog_navigation');
    this.sliderInstance = null;
    this.initSlider();
  }

  initSlider() {
    const options = {
      slidesPerView: 5.2,
      spaceBetween: 20,
      autoHeight: true,
      grabCursor: false,
      allowTouchMove: false,
      loop: false,
      navigation: {
        nextEl: ".beast_blog_next",
        prevEl: ".beast_blog_prev",
      },
      breakpoints: {
        200: { slidesPerView: 1.2, allowTouchMove: true },
        520: { slidesPerView: 2.2, allowTouchMove: true },
        768: { slidesPerView: 3.2, allowTouchMove: true },
        1024: { slidesPerView: 5.2 }
      }
    };

    this.sliderInstance = new window.FoxTheme.Carousel(this.container, options);
    this.sliderInstance.init();
  }
}

const blogSwiperEl = document.querySelector('.blog_swiper');
if (blogSwiperEl) {
  new BlogSwiper(blogSwiperEl);
}
